<template>
    <div class="row px-4">
        <div class="col-12 mt-2 mb-3" v-show="!addCompanyAssociationStatus">
            <button type="button" class="btn btn-primary add-company-button" @click="() => addCompanyAssociationStatus = true">Add Company</button>
        </div>

        <!-- Tabs -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 overflow-auto mt-2" v-show="addCompanyAssociationStatus">
            <b-tabs content-class="mt-3" lazy>
                <b-tab id="create-new-tab" title="Create New" class="card">
                    <div class="card-body bg-white">
                        <company-create-form :symbols="symbols" :masks="masks" :contact="contact" :forAssociationCompany="true" v-on:companyCreated="companyCreated"></company-create-form>
                    </div>
                </b-tab>
                <b-tab id="add-existing-tab" title="Add Existing" >
                    <div class="relative">
                        <input type="text" class="w-full pr-10 pl-4 py-2 border rounded focus:outline-none" placeholder="Search a company..."
                               v-model="filter.company_name"
                               @input="debounceFilter">
                        <div class="absolute" style="top: 6px; right: 35px;" v-if="isLoadingContacts">
                            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                        </div>
                        <i class="absolute fa fa-search mt-2 mr-2 custom-search-icon" aria-hidden="true"></i>
                    </div>
                    <div class="flex justify-between" v-if="searchedCompanies.length > 0 || searchSelectedCompanies.length > 0 ">
                        <div class="mb-1 text-grey-darkest text-sm">{{ searchedCompanies.length }} results</div>
                        <div class="mb-1 text-grey-darkest text-sm">{{ searchSelectedCompanies.length }} selected</div>
                    </div>
                    <div v-if="searchSelectedCompanies.length > 0">
                        <label class="font-medium text-grey-darkest text-md mb-2">Selected</label>
                        <div class="leading-tight selected-contact-result-section">
                            <b-form-checkbox-group
                                v-model="searchSelectedCompanies"
                            >
                                <div class="flex justify-between mb-2 mr-2"  v-for="(selectedCompany, selectedCompanyIndex) in searchSelectedCompanies">
                                    <div class="flex w-3/5 align-items-center company-contact-select-checkbox">
                                        <b-form-checkbox
                                               class="confirm-checkbox"
                                               :id="'company-selected-'+ selectedCompany.id"
                                               :name="'company-selected-'+ selectedCompany.id"
                                               :value="selectedCompany"
                                               @change="removeSelectedCompany(selectedCompany)">
                                        </b-form-checkbox>
                                        <div class="mr-3 text-base text-grey-darkest ellipsis">{{ selectedCompany.name }}</div>
                                    </div>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                    <div v-if="searchedCompanies.length > 0">
                        <hr class="lg:hidden">
                        <label class="font-medium text-grey-darkest text-md mb-2">All results</label>
                        <div class="leading-tight contact-result-section">
                            <b-form-checkbox-group
                                v-model="searchSelectedCompanies"
                            >
                                <div class="flex justify-between mb-2 mr-2"  v-for="(company, companyIndex) in searchedCompanies">
                                    <div class="d-flex flex-row align-items-center company-contact-select-checkbox">
                                        <b-form-checkbox
                                            class="confirm-checkbox"
                                            :id="'company-select-'+ company.id"
                                            :name="'company-select-'+ company.id"
                                            :value="company"
                                            :disabled="isCompanySelectionDisabled(company)">
                                        </b-form-checkbox>
                                        <div class="text-grey-darkest">{{ company.name }} {{isCompanySelectionDisabled(company) ? '(Already Associated)' : ''}}</div>
                                    </div>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                    <!-- Add Existing content here -->
                    <div v-if="searchSelectedCompanies.length > 0" class="flex justify-content-end mt-3">
                        <button @click="addAssociatedCompany" class="btn border-1 border-grey mr-1 btn-primary" >Add Now</button>
                    </div>
                </b-tab>
            </b-tabs>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 overflow-auto mt-2" v-show="addCompanyAssociationStatus">
            <button class="no-btn-properties" @click="() => addCompanyAssociationStatus = false" style="color: black;">X</button>
        </div>

        <!-- Associated Company Table -->
        <div class="col-12 overflow-auto" v-show="!addCompanyAssociationStatus">
            <table id="companiesTable" class="table table-bordered">
                <thead>
                <tr>
                    <th>Company</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Association</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="company in companies" :key="company.company_id">
                    <td>
                        <div class="d-flex flex-row align-items-center cursor-pointer" @click="goToCompany(company)">
                            <div class="px-2">
                                <div v-if="company.company_photo_url" style="display: flex;position: relative;align-items: center;justify-content: center;">
                                    <img class="logo-circle" :src="company.company_photo_url"/>
                                </div>
                                <div v-else style="display: flex;position: relative;align-items: center;justify-content: center;">
                                    <img v-if="company.is_site_logo_exists" class="logo-circle" :src="'https://logo.clearbit.com/' + company.company_website"/>
                                    <span v-else class="logo-circle" style="font-size: 32px;color: #fff;text-align: center;padding: 2px 0px 0px 4px;" v-bind:style="{ 'background': getBackgroundColor() }">{{ company.company_name.replace(/\s/g, '').charAt(0) }}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="text-left">{{ company.company_name }}</span>
                                <span class="text-grey" style="font-size: 12px;text-align: left;">{{ company.company_website }}</span>
                            </div>
                        </div>
                    </td>
                    <td>{{ company.company_phone }}</td>
                    <td>{{ company.company_address }}</td>
                    <td><span v-if="company.is_primary_company" class="badge badge-primary p-2">Primary</span></td>
                    <td>
                        <div class="dropdown">
                            <a href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-ellipsis-v"></i>
                            </a>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a v-if="!company.is_primary_company" class="dropdown-item" href="javascript:void(0)" @click="showSetPrimaryModal(company)">Set as Primary</a>
                                <a class="dropdown-item" :class="company.is_primary_company ? 'no-cursor-pointer' : ''" v-on="!company.is_primary_company ? { click: () => showRemoveAssociationModal(company) } : {}" href="javascript:void(0)" :title="company.is_primary_company ? 'The primary company cannot be removed' : ''">Remove Association</a>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Remove Association Confirmation Modal -->
        <div class="modal" id="removeAssociationModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Remove Association?</h5>
                        <button type="button" class="close" @click="hideRemoveAssociationModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{ contact.name }} will not longer be associated with {{ removeAssociationCompany ? removeAssociationCompany.company_name : '' }}</p>
                    </div>
                    <div class="modal-footer">
                        <button class="no-btn-properties mx-4" @click="hideRemoveAssociationModal()">Cancel</button>
                        <button type="button" class="btn btn-danger" @click="removeAssociation()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Set Primary Confirmation Modal -->
        <div class="modal" id="setPrimaryModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Primary Company?</h5>
                        <button type="button" class="close" @click="hideSetPrimaryModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="d-flex flex-row align-items-center px-1">
                                <div class="pr-3"><input type="checkbox" v-model="setPrimaryCompanyAllow" class="confirm-checkbox" value="true"></div>
                                <div>Replace {{ (contact.company && contact.company.name) ? contact.company.name : '' }} with {{ setPrimaryCompany ? setPrimaryCompany.company_name : '' }} as the primary company.</div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <small class="text-danger">Note: Changing the Primary company can affect this Contact's sync with any external application. Do you want to continue?</small>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="no-btn-properties mx-4" @click="hideSetPrimaryModal()">Cancel</button>
                        <button type="button" class="btn" :disabled="!setPrimaryCompanyAllow" :class="setPrimaryCompanyAllow ? 'btn-danger' : 'btn-secondary'" v-on="setPrimaryCompanyAllow ? { click: () => setPrimary() } : {}">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Form from "../../utils/form";
import axios from "axios";
import CompanyCustomFields from "../company/custom-fields/company-custom-fields.vue";

export default {
    name: "associated-companies",
    components: {CompanyCustomFields, Multiselect},
    props: ['company', 'contact', 'symbols', 'masks'],
    data() {
        return {
            companies: [],
            removeAssociationCompany: null,
            setPrimaryCompany: null,
            setPrimaryCompanyAllow: false,
            addCompanyAssociationStatus: false,
            newCompanyForm: new Form({
                id: null,
                name: null,
                address: null,
                city: null,
                state: null,
                zip: null,
                lat: null,
                lng: null,
                phone: null,
                fax: null,
                type: null,
                customFields: []
            }),
            filter: {
                company_name: '',
                timeout: null,
            },
            isLoadingContacts: false,
            searchedCompanies: [],
            searchSelectedCompanies: [],
            companyTypes: []
        }
    },
    mounted() {
        this.getCompaniesList();
        this.getCompanyTypes();
    },
    methods: {
        getCompaniesList() {
            let self = this;
            axios.get(route('api.contact.company-association.list-companies', {contactId: self.contact.id})).then((response => {
                self.companies = _.orderBy(response.data.data, ['is_primary_company'], ['desc']);
                _.map(self.companies, function(company) {
                    self.scrFileStatus(company);
                    return company;
                });
            })).catch((error) => {
                //
            });
        },
        showRemoveAssociationModal(company) {
            this.removeAssociationCompany = company;
            $("#removeAssociationModal").modal("show");
        },
        hideRemoveAssociationModal() {
            this.removeAssociationCompany = null;
            $("#removeAssociationModal").modal("hide");
        },
        showSetPrimaryModal(company) {
            this.setPrimaryCompany = company;
            $("#setPrimaryModal").modal("show");
        },
        hideSetPrimaryModal() {
            this.setPrimaryCompany = null;
            $("#setPrimaryModal").modal("hide");
        },
        removeAssociation() {
            let self = this;
            let company = self.removeAssociationCompany;
            $("#removeAssociationModal").modal("hide");
            self.removeAssociationCompany = null;
            axios.post(route('api.contact.company-association.remove-association'), {data: company}).then((response => {
                self.getCompaniesList();
            })).catch((error) => {
                //
            });
        },
        setPrimary() {
            let self = this;
            let company = self.setPrimaryCompany;
            $("#setPrimaryModal").modal("hide");
            self.setPrimaryCompany = null;
            axios.post(route('api.contact.company-association.set-primary'), {data: company}).then((response => {
                window.location = response.data;
            })).catch((error) => {
                //
            });
        },
        initAutocompleteCompany() {
            //
        },
        debounceFilter(event) {
            clearTimeout(this.filter.timeout);
            const inputValue = event.target.value;
            if (inputValue.length > 2) {
                this.filter.timeout = setTimeout(() => {
                    if(event.target.value === ''){
                        this.isLoadingContacts = false;
                    }else{
                        this.isLoadingContacts = true;
                        this.fetchCompanies(event.target.value);
                    }
                }, 700, this);
            }
        },
        fetchCompanies(filter) {
            let self = this;
            self.filter.company_name = filter;
            let searchSelectedCompanyIds = _.map(self.searchSelectedCompanies, 'id');
            axios.post(route('api.company.searched.results'), {filter: self.filter.company_name}).then(({data}) => {
                self.searchedCompanies = data.data;
                self.isLoadingContacts = false;
            })
            .catch(error => {
                self.isLoadingContacts = false;
            });
        },
        removeSelectedCompany(company) {
            this.$nextTick(() => {
                _.forEach(this.searchSelectedCompanies, function(company) {
                    $('#company-selected-' + company.id).prop('checked', true);
                });
            });
        },
        addAssociatedCompany() {
            let self = this;
            let searchSelectedCompanyIds = _.map(self.searchSelectedCompanies, 'id');
            let payload = {contact: self.contact, companies: JSON.stringify(searchSelectedCompanyIds)};
            axios.post(route('api.contact.company-association.add-associating-companies'), payload).then((response) => {
                self.filter.company_name = '';
                self.filter.timeout = null;
                self.addCompanyAssociationStatus = false;
                self.getCompaniesList();
                self.searchedCompanies = [];
                self.searchSelectedCompanies = [];
            }).catch(function(error) {
                //
            });
        },
        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index') ).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id: null, code: ""})
            }).catch((error) => {
                //
            });
        },
        createCompany() {
            this.newCompanyForm.customFields = this.$refs["company-custom-fields"].form;
        },
        isCompanySelectionDisabled(company) {
            let exists = _.find(this.companies, function(com) { return com.company_id == company.id });
            return (exists !== null && exists !== undefined);
        },
        imageExists(url, callback) {
            var img = new Image();
            img.onload = function() { callback(true); };
            img.onerror = function() { callback(false); };
            img.src = url;
        },
        scrFileStatus(company) {
            const self = this;
            var imageUrl = 'https://logo.clearbit.com/' + company.company_website;
            self.imageExists(imageUrl, function(exists) {
                company.is_site_logo_exists = exists;
            });
        },
        getBackgroundColor() {
            let x = 137;
            let y = 100 + Math.floor(Math.random() * 256);
            let z = 50 + Math.floor(Math.random() * 256);
            return "rgb(" + x + "," + y + "," + z + ")";
        },
        companyCreated() {
            this.getCompaniesList();
        },
        goToCompany(company) {
            if(company && !company.is_residential) {
                window.location = route('company.show', {company: company.company_id});
            }
        }
    }
}
</script>

<style scoped>
#companiesTable td {
    text-align: center;
    vertical-align: middle;
}
.add-company-button {
    border-radius: 20px;
    padding: 9px 15px;
    font-weight: 200;
}
.no-cursor-pointer {
    cursor: not-allowed !important;
}
.no-btn-properties {
    background: none;
    color: #01B1AF;
    border: none;
    box-shadow: none;
}
.modal-title {
    font-weight: 600;
}
.confirm-checkbox {
    transform: scale(1.3) !important;
}
.company-contact-select-checkbox .custom-control {
    margin-top: unset !important;
    margin-right: unset !important;
}
.company-custom-field-create {
    padding-left: unset !important;
    padding-right: unset !important;
}
.logo-circle {
    height: 50px;
    width: 50px;
    margin: 0 auto;
    margin-bottom: 10px;
    border-radius: 50%;
}
</style>
